module.exports = __webpack_public_path__ + "img/addRemarkWhite.59a29329.svg";